/**
 * VisualMapIcon
 *
 * A large button that changes from the list to the map view.
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.VisualMapIcon');

OT.Redesign.Views.VisualMapIcon = Backbone.ViewManager.BaseView.extend({
  el: '.visual_map_icon',

  events: {
      click: 'toggle'
  },

  reloadView: function(currentView) {
    OT.Search.Params.set({
        CurrentView: currentView,
        ShowMap: true
    });

    this.viewChanged();
  },

  viewChanged: function() {
      OT.Search.Requests.Results.get({
          supressSearchHistory: true
      });
  },

  toggle: function(e) {
      e.preventDefault();

      var selectedView = 'map';

      if (window.OTSearchData.Experiments.sv1493) {
        window.OTSearchBundle.changeView(selectedView);
      }

      OT.Search.Params.set({
          CurrentView: selectedView
      });

      this.reloadView(selectedView);
  }
});
